import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import {
  IoMdLeaf,
  IoMdSunny,
  IoMdNutrition,
  IoMdFemale,
  IoMdPeople,
  IoMdGitNetwork,
  IoMdCheckmarkCircle
} from "react-icons/io";


import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/banner3.jpg';
import cln2 from '../assets/banner4.jpg';
import cln3 from '../assets/banner6.jpg';
import cln4 from '../assets/banner4.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Micro-credit Entity Registration at BOT
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

								<h6
									style={{
										fontSize: "18px",
										marginTop: "45px",
										marginBottom: "35px",
										textAlign: "center"
									}}
								>
									
								</h6>

								<h5>
									We assist in registering microfinance and credit entities with the Bank of Tanzania. 
									<br/><br/>
									Our team ensures all regulatory requirements are met, helping your microcredit institution operate legally and efficiently from day one.
								</h5>

								
							</div>

						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}